import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OnboardingClient } from 'src/app/shared/models/onboarding/onboarding-client';
import { OnboardingClientStep } from 'src/app/shared/models/onboarding/onboarding-client-step';

import { OnboardingService } from 'src/app/services/onboarding.service';
import { StepChanged } from 'src/app/shared/models/onboarding/step-changed';
import { HttpErrorResponse } from '@angular/common/http';
import { OnboardingClientCategory } from 'src/app/shared/models/onboarding/onboarding-client-category';
import { SettingsService } from 'src/app/services/settings.service';
import { Note } from 'src/app/shared/models/note/note';

import { formatDate } from '@angular/common';

@Component({
  selector: 'app-categories-steps',
  templateUrl: './categories-steps.component.html',
  styleUrls: ['./categories-steps.component.scss'],
})
export class CategoriesStepsComponent implements OnInit {
  @Input() onboardingClient: OnboardingClient;
  @Input() isWealth: boolean = false;
  @Output() stepNoteAdded = new EventEmitter<Note>();

  errorResponse: HttpErrorResponse;
  showError: boolean = false;
  showSteps: boolean = false;
  updatedByUserId: number;
  updatedByUserName: string;

  constructor(
    private onboardingService: OnboardingService,
    private settingsService: SettingsService
  ) {
    this.updatedByUserId = this.settingsService.user.id;
    this.updatedByUserName = this.settingsService.userProfile.displayName;
  }

  ngOnInit(): void {}

  toggleStepUpdate(step: OnboardingClientStep) {
    step.isUpdating = true;
    step.recentlyUpdated = false;
    step.updateSuccess = false;
    step.error = null;

    if (step.emailTemplateId) {
      step.isCompleted = true;
    }

    this.onboardingService.UpdateStep(this.onboardingClient.userId, step.id, step.isCompleted, this.updatedByUserId).subscribe({
      next: (response: StepChanged) => {
        step.recentlyUpdated = true;
        setTimeout(() => {
          step.recentlyUpdated = false;
        }, 3000);

        this.addStepNote(step);
      },
      error: (error) => {
        this.errorResponse = error;
        step.error = error;
        step.isCompleted = !step.isCompleted;
        this.showError = true;
        step.isUpdating = false;
      },
      complete: () => {
        // TODO: figure out why this never runs when an error happens. Documentation says it will always run
        step.isUpdating = false;
      },
    });
  }

  markEmailStepAsSent(step: OnboardingClientStep) {
    if (step.isCompleted) {
      return;
    }

    const previousCompleted = step.isCompleted;
    const previousLastUpdatedDate = step.lastUpdatedDate;

    step.isUpdating = true;
    step.recentlyUpdated = false;
    step.updateSuccess = false;
    step.error = null;
    step.isCompleted = true;

    this.onboardingService.MarkEmailStepAsSent(this.onboardingClient.userId, step.id, this.updatedByUserId).subscribe({
      next: () => {
        step.recentlyUpdated = true;
        step.lastUpdatedDate = new Date();
        setTimeout(() => {
          step.recentlyUpdated = false;
        }, 3000);

        this.addStepNote(step);
      },
      error: (error) => {
        this.errorResponse = error;
        step.error = error;
        step.isCompleted = previousCompleted;
        step.lastUpdatedDate = previousLastUpdatedDate;
        this.showError = true;
        step.isUpdating = false;
      },
      complete: () => {
        step.isUpdating = false;
      },
    });
  }

  onCategoryClick(category: OnboardingClientCategory) {
    category.showSteps = !category.showSteps;
  }

  stepIsVisible(category: OnboardingClientCategory): boolean {
    if (category.showSteps == null) {
      if (category.hasStarted && !category.isCompleted) {
        return true;
      }
    }

    return category.showSteps;
  }

  generateLastUpdatedDate(step: OnboardingClientStep) {
    let dateToFormat = new Date();
    if (step.lastUpdatedDate) {
      dateToFormat = step.lastUpdatedDate;
    }

    return formatDate(dateToFormat, 'dd MMM yyyy HH:mm', 'en-US');
  }

  popupError(error: HttpErrorResponse) {
    //Note: the spread operator here ... creates a new instance of the error so that the onChanges can detect the change in the errorcomponent
    this.errorResponse = { ...error };
    this.showError = true;
  }

  private addStepNote(step: OnboardingClientStep) {
    const notePrefix = step.isCompleted ? 'Completed:' : 'Reverted:';

    let addedNote: Note = new Note();
    addedNote.id = 0;
    addedNote.clientId = this.onboardingClient.userId;
    addedNote.note = `${notePrefix} ${step.description}`;
    addedNote.dateTimeCreated = new Date();
    addedNote.createdByUserId = this.updatedByUserId;
    addedNote.createdByUserFullName = this.updatedByUserName;

    this.stepNoteAdded.emit(addedNote);
  }
}
